import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

// AI 动作定义
const aiActions = defineAIActions({
  namespace: 'content',
  actions: [
    {
      id: 'generate-title',
      name: '生成标题',
      description: '使用AI生成吸引眼球的标题',
      parameters: [
        { name: 'topic', type: 'string', description: '内容主题', required: true },
        { name: 'style', type: 'string', description: '风格', required: false },
      ],
      handler: async (params) => {
        // 模拟AI生成
        const titles = [
          `【必看】${params.topic}的10个实用技巧`,
          `${params.topic}入门指南，新手必备！`,
          `跟着做！${params.topic}超简单教程`,
        ];
        return {
          type: 'text',
          data: titles,
          message: '已生成3个标题建议',
        };
      },
    },
    {
      id: 'rewrite-content',
      name: '改写文案',
      description: '优化和改写内容文案',
      parameters: [
        { name: 'content', type: 'string', description: '原始内容', required: true },
        { name: 'tone', type: 'string', description: '语气风格', required: false },
      ],
      handler: async (params) => {
        return {
          type: 'text',
          data: `优化后的内容：\n${params.content}\n\n（已优化语言表达，提升吸引力）`,
          message: '内容改写完成',
        };
      },
    },
    {
      id: 'generate-tags',
      name: '推荐标签',
      description: '智能推荐相关标签和话题',
      parameters: [
        { name: 'content', type: 'string', description: '内容描述', required: true },
      ],
      handler: async (params) => {
        const tags = ['护肤', '美妆', '好物推荐', '平价', '学生党', '新手入门'];
        return {
          type: 'table',
          data: tags.map(tag => ({ tag, popularity: Math.floor(Math.random() * 100) })),
          message: `推荐了 ${tags.length} 个相关标签`,
        };
      },
    },
  ],
});

// 导出插件定义
export default definePlugin({
  meta: {
    name: 'content-manager',
    version: '1.0.0',
    displayName: '内容管理',
    description: '小红书内容的创作、编辑、素材管理和发布',
    icon: 'file-text',
    category: 'core',
  },

  onLoad: async () => {
    console.log('[Plugin] Content Manager loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Content Manager unloaded');
  },

  routes: [
    {
      path: '/content',
      lazy: async () => {
        const { ContentList } = await import('./pages/ContentList');
        return { Component: ContentList };
      },
    },
    {
      path: '/content/new',
      lazy: async () => {
        const { ContentEditor } = await import('./pages/ContentEditor');
        return { Component: ContentEditor };
      },
    },
    {
      path: '/content/:id/edit',
      lazy: async () => {
        const { ContentEditor } = await import('./pages/ContentEditor');
        return { Component: ContentEditor };
      },
    },
    {
      path: '/content/templates',
      lazy: async () => {
        const { TemplateList } = await import('./pages/TemplateList');
        return { Component: TemplateList };
      },
    },
    {
      path: '/content/assets',
      lazy: async () => {
        const { AssetLibrary } = await import('./pages/AssetLibrary');
        return { Component: AssetLibrary };
      },
    },
  ],

  sidebarMenus: [
    {
      id: 'content',
      title: '内容管理',
      icon: 'file-text',
      path: '/content',
      order: 2,
    },
  ],

  aiActions,
});

